import Image from "next/image";
import React, { Component } from "react";

class StepProfileContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
    };
  }

  render() {
    return (
      <>
        {" "}
        <div className="profile__section__main">
          <div className="signup__heading">
            Lets gather some information so we can match you with the right
            co-founder
          </div>
          <div className="profile__picture__section">
            {" "}
            <Image
              src="/static/images/startupIcon.svg"
              alt="Find a co-founder today"
              height={180}
              width={150}
              priority={true}
            />
          </div>
          <div className="profile__content__section">
            <p>Tell us more about your startup journey.</p>
          </div>
          <div className="profile__picture__section">
            {" "}
            <Image
              src="/static/images/fewClickAway.svg"
              alt="Find a co-founder today"
              height={180}
              width={150}
              priority={true}
            />
          </div>
          <div className="profile__content__section">
            <p>You are only a few clicks away now!</p>
          </div>
          <div className="profile__picture__section tips__section">
            {" "}
            <Image
              src="/static/images/bulbBig.svg"
              alt="Find a co-founder today"
              height={400}
              width={400}
              priority={true}
            />
          </div>
        </div>
      </>
    );
  }
}

export default StepProfileContent;
